import styled from '@emotion/styled';

import COLOR from '../../../../shared/constant/colorset';

const ReviewSectionHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 44px;
`;

const ReviewSectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 41px;
  color: ${COLOR.kurlyGray800};
`;

export default function ReviewHeader() {
  return (
    <ReviewSectionHeader>
      <ReviewSectionTitle aria-label="product-review">상품 후기</ReviewSectionTitle>
    </ReviewSectionHeader>
  );
}
